import {
  RichContentWrapperComponent,
  ContentProductCarouselComponent,
  BannerImageWrapperComponent,
  CustomLinkedComponent,
  ContentCardListComponent,
  ContentCardComponent,
  CategoryGridComponent,
  HeroBannerComponent,
  ColumnContentWrapperComponent,
  DividerComponent,
  CustomSignUpComponent,
  HeadLineBannerComponent,
  BrandListWrapperComponent,
  AdvancedCarouselComponent,
  NewsletterWrapperComponent,
  SeoContentWrapperComponent,
  SubCategoryGridWrapperComponent,
  UspGridComponent,
  CategoryCarouselWrapperComponent,
  CategoryProductsCatalogWrapperComponent,
  PopularLinksComponent, RelatedCategoriesComponent,
} from '~app/modules/storyblok/components';
import { SeoFaqContentComponent } from '~shared/modules/seo/components';

export const Components = {
  newsletter: NewsletterWrapperComponent,
  banner: BannerImageWrapperComponent,
  'rich-content': RichContentWrapperComponent,
  'faq-content': SeoFaqContentComponent,
  'product-carousel': ContentProductCarouselComponent,
  'advanced-carousel': AdvancedCarouselComponent,
  'custom-linked-grid': CustomLinkedComponent,
  'content-card-list': ContentCardListComponent,
  'content-card': ContentCardComponent,
  'category-carousel': CategoryCarouselWrapperComponent,
  'recommended-products-carousel': ContentProductCarouselComponent,
  'category-grid': CategoryGridComponent,
  'hero-banner': HeroBannerComponent,
  headlineBanner: HeadLineBannerComponent,
  'column-content': ColumnContentWrapperComponent,
  'custom-sign-up': CustomSignUpComponent,
  divider: DividerComponent,
  'sub-category-grid': SubCategoryGridWrapperComponent,
  'usp-grid': UspGridComponent,
  'brand-list': BrandListWrapperComponent,
  'seo-content': SeoContentWrapperComponent,
  'products-catalog': CategoryProductsCatalogWrapperComponent,
  'popular-links': PopularLinksComponent,
  'related-categories': RelatedCategoriesComponent,
};
